import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { RoleType } from "../../types/Role";
import { get } from "../../utils/axios-config";
import { ROLES } from "../../utils/constants";

export const getRoles = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.UserId ? { UserId: data.UserId } : {}),
        ...(data?.Role ? { Role: data.Role } : {}),
    });
    const url = `${ROLES}?${queryParams.toString()}`;
    return await get<PagedResultsType<RoleType>>(url)
};